import httpClient from "Api/httpClient";

const END_POINT = "/firmware";

const getFirmwareVersions = (payload) => {
	let body = "";
	if (payload.body) body = payload.body;
	return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

export { getFirmwareVersions };